import React, { Suspense, useEffect, useState } from "react";
import {
  Box,
  Paper,
  Title,
  createStyles,
  Avatar,
  Text,
  Select,
  Input,
  Group,
  Button,
  Tabs,
  SimpleGrid,
  Checkbox,
  Radio,
  Textarea,
  Progress,
  Loader,
  Flex,
  Modal,
} from "@mantine/core";
import { IconDownload, IconEye, IconTrash } from "@tabler/icons-react";
import fileSvg from "../../assets/img/file.svg";
import { useMedplum } from "@medplum/react";
import JSONPretty from "react-json-pretty";
import { url } from "inspector";
import Highlight from "react-highlight";

const useStyles = createStyles(() => ({
  box1: {
    display: "flex",
    flexDirection: "row",
  },
  patientGropuTitle: {
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "22px",
    color: "#262930",
    paddingLeft: "16px",
  },

  scrollBar: {
    height: "76vh",
    overflowY: "auto",
  },
}));

interface DownloadFileProps {
  fileData?: any;
  handleDowload?: (fileObject: any, download?: boolean) => Promise<void>;
  onDelete?: () => void;
  loader?: [number[], React.Dispatch<React.SetStateAction<number[]>>];
  open:boolean
  close?:any
  fileName?:string
  fileType?:string
  url?:string
}

export const FileViewer: React.FC<DownloadFileProps> = ({
  fileData,
  open,
  close,
  handleDowload,
  onDelete,
  loader,
  fileName,fileType,url
}) => {
  const { classes } = useStyles();
  const medplum = useMedplum();
  // const [dLoader, setDLoader] = loader;
//   const handleDownClick = async (file: any, index: number) => {
//     setDLoader([...dLoader, index]);
//     await handleDowload(file, true);
//     setDLoader(dLoader.filter((i) => i != index));
//   };
  return (
    <Modal
      // title={fileNae}
      opened={open}
      onClose={close}
      size="xl"
      withCloseButton={true}
      closeOnEscape={true}
      closeOnClickOutside={true}
    >
      
        <>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              paddingBottom: "12px",
            }}
          >
            <Flex align="center">
              <Title className={classes.patientGropuTitle}>{fileName}</Title>
            </Flex>{" "}
            <Button onClick={handleDowload}>
              <IconDownload />
              <Text ml={8}>Download</Text>
            </Button>
          </Box>
          {fileType?.includes("pdf") && (
            <iframe
              title="PDF Viewer"
              src={url}
              style={{content:"fit", width: "100%", height: "76vh", border: "none" }}
            />
          )}
          {fileType === "xml" && (
            <Suspense fallback={<div>Loading...</div>}>
              <Box className={classes.scrollBar}>
                <Highlight className="xml">{fileData}</Highlight>
              </Box>
            </Suspense>
          )}
          {fileType === "rtf" && (
            <Box
              className={classes.scrollBar}
              dangerouslySetInnerHTML={{ __html: fileData }}
            />
          )}

         
        </>
     
     
    </Modal>
  );
};
